var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"token"},[_c('h1',[_vm._v("Sono 10 giorni che manca la connessione internet ...")]),_c('img',{attrs:{"src":`${_vm.publicPath}img/ubisell-logo.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }